import { MILESTONE_STATUSES_RU as MS } from '../../helpers/report';
import {
  isAdmin, isStrategyTeam, isPortfolioTeam, isProjectTeam, isPolicyTeam,
} from '../rolesSvc';

const rules = {
  Read: {
    isStatusOk: (status) => true,
    isRoleOk: (userCtx, stratId, portfId, projId, policyId) => isProjectTeam(userCtx, projId) || isPortfolioTeam(userCtx, portfId) || isPolicyTeam(userCtx, policyId) || isStrategyTeam(userCtx, stratId) || isAdmin(userCtx),
  },
  Edit: {
    isStatusOk: (status) => true,
    isRoleOk: (userCtx, stratId, portfId, projId, policyId) => isProjectTeam(userCtx, projId) || isPortfolioTeam(userCtx, portfId) || isPolicyTeam(userCtx, policyId) || isStrategyTeam(userCtx, stratId) || isAdmin(userCtx),
    extra: (status, userCtx, stratId, portfId, projId, policyId) =>
      isAdmin(userCtx) // ПО редактирует всегда
      || status !== MS.published.key && isStrategyTeam(userCtx, stratId) // команда СП может редактировать факт всегда, кроме статуса "Опубликована"
      || [MS.new.key, MS.notApproved.key, MS.withoutPublish.key].includes(status) // команды проекта, портфеля и политики (когда нет СП) могут редактировать, пока веха не ушла на согласование
      && (!stratId && isPolicyTeam(userCtx, policyId) || isPortfolioTeam(userCtx, portfId) || isProjectTeam(userCtx, projId)),
  },
  Send: {
    isStatusOk: (status) => [MS.new.key, MS.notApproved.key].includes(status),
    isRoleOk: (userCtx, stratId, portfId, projId, policyId) => isAdmin(userCtx) || isStrategyTeam(userCtx, stratId) || !stratId && isPolicyTeam(userCtx, policyId) || isPortfolioTeam(userCtx, portfId) || isProjectTeam(userCtx, projId),
  },
  Approve: {
    isStatusOk: (status) => [MS.onApprove.key].includes(status),
    isRoleOk: (userCtx, stratId, portfId, projId, policyId) => isAdmin(userCtx) || isStrategyTeam(userCtx, stratId), // согласовывает либо ПО, либо команда СП (у политик согласовывает ПО)
  },
};

export const getActionsModel = (status, userCtx, stratId, portfId, projId, policyId) => Object.entries(rules).reduce((acc, [key, rule]) => ({
  ...acc,
  [key]: rule.isStatusOk(status) && rule.isRoleOk(userCtx, stratId, portfId, projId, policyId) && (!rule.extra || rule.extra(status, userCtx, stratId, portfId, projId, policyId)),
}), {});
